import isEqual from 'lodash/isEqual';
import { useEffect, useRef } from 'react';

import { EventBus } from './EventBus';
import { EventBusEvent, EventBusPayload } from './EventBus.types';

const EMPTY_ARRAY: any[] = [];

export const useEvent = <E extends EventBusEvent>(
  event: E,
  callback: (payload: EventBusPayload<E>) => Promise<void> | void,
  deps: any[] = EMPTY_ARRAY,
) => {
  const previousDepsRef = useRef<any[]>();
  const stableDepsRef = useRef<any[]>(EMPTY_ARRAY);

  const currentDeps = deps.length === 0 ? EMPTY_ARRAY : deps;
  const depsChanged = !previousDepsRef.current || !isEqual(previousDepsRef.current, currentDeps);

  if (depsChanged) {
    previousDepsRef.current = currentDeps;
    stableDepsRef.current = currentDeps === EMPTY_ARRAY ? EMPTY_ARRAY : [...currentDeps];
  }

  useEffect(() => {
    return EventBus.on(event, callback);
  }, stableDepsRef.current);
};
